import React, { useContext } from "react";

// style
import Style from "./ModalDiscardChanges.module.css";

// context
import { AdminDashboardContext } from "../../../../../context/AdminDashboardContext";

// fontawesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const ModalDiscardChanges = () => {
  const {
    setModalDiscardChangesIsOpen,
    handleEditable,
    setProjectEditable,
    setProjectLocked,
  } = useContext(AdminDashboardContext);

  const handleYesButton = () => {
    handleEditable();
    setProjectEditable(false);
    setProjectLocked(true);
    setModalDiscardChangesIsOpen(false);
  };

  const handleNoButton = () => {
    setModalDiscardChangesIsOpen(false);
  };

  const closeModal = () => {
    setModalDiscardChangesIsOpen(false);
  };

  return (
    <div className={Style.ModalContainerOverlay}>
      <div className={Style.Modal}>
        <div className={Style.ModalTopContainer}>
          <button className={Style.ModalClose} onClick={() => closeModal()}>
            <FontAwesomeIcon icon={faXmark} size="1x" />
          </button>
          <h3 className={Style.ModalQuestion}>Odbaci promjene?</h3>
        </div>

        <div className={Style.ModalButtonsContainer}>
          <button
            onClick={() => handleYesButton()}
            className={Style.ModalButton}
          >
            DA
          </button>
          <button
            onClick={() => handleNoButton()}
            className={Style.ModalButton}
          >
            NE
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalDiscardChanges;
